import { forwardRef, useState } from 'react';
import { IconButton, InputAdornment, TextFieldProps } from '@mui/material';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import { LargeTextfield } from '@/components/CustomTextfield/styles';

const PasswordField = forwardRef<HTMLInputElement, TextFieldProps>(({ ...props }, ref) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <LargeTextfield
      {...props}
      ref={ref}
      type={showPassword ? 'text' : 'password'}
      slotProps={{
        input: {
          autoComplete: 'current-password',
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={togglePasswordVisibility}>
                {showPassword ? <VisibilityOffOutlinedIcon /> : <VisibilityOutlinedIcon />}
              </IconButton>
            </InputAdornment>
          ),
        },
      }}
    />
  );
});

export default PasswordField;
